import { SxProps } from "@mui/material";

export const sxButtonMenu: SxProps = {
  display: "flex",
  flexDirection: "column",
  marginTop: "20px",
  borderRadius: "3px"
};
